
export const getFormattedMediaLibraryFilename = (name: string): string => {
  return name.substring(0, name.lastIndexOf("-"));
}

export const getMediaLibraryFileFormat = (name: string): string => {
  return name.substr(name.lastIndexOf('.') + 1);
}

